import React, { PureComponent } from 'react'
import Helmet from 'react-helmet'
import moment from 'moment'
import actions from 'redux/actions'

import 'helpers/scss/global.scss'

import { connect } from 'redaction'
import { getProjectName, compose, generateConstants, getCityName } from 'helpers'
import 'moment/locale/ru'

import injectGlobals from 'local_modules/injectGlobals'

import ModalConductor from 'components/modals/ModalConductor/ModalConductor'

import Overlay from './Overlay/Overlay'

import s from './App.scss'

class App extends PureComponent {

  UNSAFE_componentWillMount() {
    const { host } = this.props

    // const cityName  = getCityName({ host })

    // if (cityName === 'sarov') {
    //   setCategories({
    //     id: 'rpc',
    //     title: 'Православная гимназия',
    //   })
    // }

    if (process.env.WEBPACK === 'site.dev') {
      window.moment = moment
    }
    if (process.env.WEBPACK === 'build.client') {
      console.log('generate constants')
      generateConstants(host)
    }
  }

  componentDidMount() {
    const { host } = this.props
    const cityName  = getCityName({ host })

    if (cityName === 'sarov') {
      actions.marketplace.layersNavigation.setCategories([
        {
          id: 'sport',
          title: 'Спорт и досуг',
        },
        {
          id: 'edu',
          title: 'Образование',
        },
        {
          id: 'rpc',
          title: 'Православная гимназия',
        },
      ])
    }
  }

  componentWillReceiveProps({ pathname }) {
    const { pathname: oldPathname} = this.props

    if (pathname !== oldPathname) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { children, isLoaderVisible, title, text } = this.props

    return (
      <div className={s.app}>
        <Helmet
          title={title}
        />
        {
          isLoaderVisible && (
            <Overlay key="overlay" isVisible={isLoaderVisible}>
              {
                Boolean(text) && (
                  <div>{text}</div>
                )
              }
            </Overlay>
          )
        }
        <div key="children">{children}</div>
        <ModalConductor key="modals" />
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ globals }) => ({
    host: globals.host,
  })),
  connect({
    isLoaderVisible: 'ui.isRequestLoaderVisible',
    text: 'ui.text',
    pathname: 'routing.locationBeforeTransitions.pathname',
    title: (state, { host }) => {
      const project   = getProjectName(state)
      const cityName  = getCityName({ host })

      const defaultTitle = state.me.city.title || ({
        sarov: 'Умный Саров',
        zv: 'Умный Железноводск',
        snz: 'Умный Снежинск',
      })[cityName]

      const _title = ({
        voting: 'Голосование',
        heroes: 'Бессмертный полк',
        dashboard: 'Ситименеджер',
        marketplace: 'Платные услуги',
        lscSchedules: 'Формирование разнарядки',
        emergencyAlert: 'Аварийное оповещение',
        lscVideoDownload: 'Выгрузка видео',
        lscTransportControl: 'Формирование разнарядки',
      })[project]

      const title = _title ? `${_title} | ${defaultTitle}` : defaultTitle

      if (project === 'marketplace') {
        const { marketplace: { layersNavigation: { category, categories, tools, toolType, area } } } = state

        const selectedCategory = category && categories.find(({ id }) => id === category)

        if (selectedCategory) {
          const selectedToolType = category === 'sport' && tools.find(({ id }) => id === toolType)

          if (selectedToolType) {
            const selectedTool = selectedToolType.areas.find(({ id }) => id === area)

            if (selectedTool) {
              return `${selectedTool.name} - ${title}`
            }

            return `${selectedToolType.name} - ${title}`
          }

          return `${selectedCategory.title} - ${title}`
        }
      }

      return title
    },
  })
)(App)